import React from "react";
import { FaHome } from "react-icons/fa";
import breadcumbBG from "../assets/images/Banner_BG.jpg"; // replace with real image
import { Link } from "react-router-dom";


// Reusable Breadcrumb component
const Breadcrumb = ({ title, path }) => {
    return (
        <section style={{
            backgroundImage: `url(${breadcumbBG})`,
        }} className="bg-cover bg-center pt-28 pb-16 text-white relative">
            <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold text-center">{title}</h2>
                <div className="flex items-center justify-center gap-2 mt-2 text-sm">
                    <FaHome />
                    <Link to={'/'}>Home</Link>
                    {path && (
                        <>
                            <span>/</span>
                            <span>{path}</span>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Breadcrumb;
